import React from "react";
import PropTypes from "prop-types";

import styles from "./SearchHeader.module.css";

const createMarkup = (markup) => {
  return { __html: markup };
};

const SearchHeader = ({ title, query }) => {
  return (
    <>
      <h1>
        <span
          className={styles.subHeader}
          dangerouslySetInnerHTML={createMarkup(title)}
        />
        <span className={styles.header}>&quot;{query}&quot;</span>
      </h1>
    </>
  );
};

export default SearchHeader;

SearchHeader.propTypes = {
  title: PropTypes.string.isRequired,
  query: PropTypes.string.isRequired,
};
